/** מצבי Workflow בשיחה — ייושרו לבקאנד בהמשך */
export type WorkflowStatusId = 1 | 2 | 3 | 4 | 5 | 6;

export const WORKFLOW_STATUS_IDS: WorkflowStatusId[] = [1, 2, 3, 4, 5, 6];

/**
 * מעבר ידני מותר רק להקפאה (5) ולסיום (6) — הוחלט 26.10. שאר הסטטוסים נקבעים
 * אוטומטית על ידי המערכת (שיוך נציג, הודעה נכנסת/יוצאת) ומוצגים בתפריט מושבתים.
 */
export const MANUAL_FLOW_STATUS_SELECTABLE_IDS: WorkflowStatusId[] = [5, 6];

/** תוויות הסטטוסים — אותו נוסח כמו chat.infoChip.status בלוקאלים */
export const WORKFLOW_STATUS_LABELS: Record<WorkflowStatusId, string> = {
  1: 'לשיוך לנציג',
  2: 'למענה ראשוני',
  3: 'לאיש קשר',
  4: 'להמשך מענה',
  5: 'בהקפאה',
  6: 'הסתיימה',
};

/**
 * אופציות סינון לפי flowStatusCode — מקור אחד לבורר התצוגות המותאמות ולקטלוג
 * לוחות הבקרה. הערכים מחרוזות ('1'..'6') כי כך שני הבוררים מחזיקים ערכי select;
 * ההשוואה בשרת מול עמודה מספרית עוברת המרה.
 */
export const WORKFLOW_STATUS_FILTER_OPTIONS: Array<{ value: string; label: string }> =
  WORKFLOW_STATUS_IDS.map((id) => ({ value: String(id), label: WORKFLOW_STATUS_LABELS[id] }));

/**
 * ה-slug הטקסטואלי של הסטטוס (Sessions.flow_status) מול הקוד. אומת מול ה-DB:
 * שתי העמודות צמודות 1:1 בכל השורות. בלוחות הבקרה מקבצים לפי העמודה הטקסטואלית,
 * ולכן צריך לתרגם ממנה לאותן תוויות שהצ'אט מציג.
 */
export const WORKFLOW_STATUS_CODE_BY_SLUG: Record<string, WorkflowStatusId> = {
  unassigned: 1,
  assigned: 2,
  waiting_for_customer: 3,
  waiting_for_agent: 4,
  snoozed: 5,
  completed: 6,
  /** כינויים היסטוריים שהופיעו בנתונים/בקוד לפני שהקודים התייצבו */
  waiting_for_reply: 4,
  waiting_response: 4,
  on_hold: 5,
  ended: 6,
};

export const WORKFLOW_STATUS_SLUGS: string[] = ['unassigned', 'assigned', 'waiting_for_customer', 'waiting_for_agent', 'snoozed', 'completed'];

export const WORKFLOW_STATUS_SLUG_LABELS: Record<string, string> = Object.fromEntries(
  Object.entries(WORKFLOW_STATUS_CODE_BY_SLUG).map(([slug, code]) => [slug, WORKFLOW_STATUS_LABELS[code]]),
);
